<template>
  <el-select
      :model-value='modelValue'
      @update:model-value='change'
    filterable
    remote
    clearable
    reserve-keyword
    :placeholder="placeholder"
    @change="change"
    :loading="loading">
    <el-option
      v-for="(item,key) in options"
      :key="item"
      :label="item"
      :value="item">
    </el-option>
  </el-select>
</template>

<script setup>
import newRequest from '@/utils/request'
import {ref} from "vue";

const options = ref([])
const loading = ref(false)

const props= defineProps({
  modelValue:{
    modelValue:String,
    name:String,
    placeholder:{
      type:String,
      default:'请输入关键词'
    }

  }
})
const emits = defineEmits(['update:modelValue'])

const load=async (query)=> {
      const res = await  newRequest.get("controller/term/term/getTermAll", {})
      const { message,success } = res
      if (success ) {
        options.value = res.datas.data
      }
      emits('update:modelValue',options.value[0])
    }
load()
const  change = (code)=> {
      emits('update:modelValue',code)
      /*this.$emit('update:modelValue', code)
      let selectName=this.options.find(val=>val[this.code]==code)[this.label]
      this.$emit('update:name', selectName)*/
    }
</script>
